export enum DEFAULT_ORDER_VIEW_NAME {
  all = 'all',
  myTasks = 'my_tasks',
  proposedOrders = 'proposed_orders',
  // Костыль для переадресации на дефолтный view
  fakeViewName = 'orderViewName',
}

export enum ORDER_CUSTOM_VISIBILITY_FIELD {
  createdAt = 'createdAt',
  visitDateIntervals = 'visitDateIntervals',
  status = 'status',
  brand = 'brand',
  technicians = 'technicians',
  customerPhones = 'customer.phones',
  legalEntity = 'legalEntity',
  region = 'region',
  shop = 'shop',
  address = 'address',
  productDeliveryIntervals = 'productDeliveryIntervals',
  customerName = 'customer.name',
  customerVip = 'customer.vip',
  customerEmail = 'customer.email',
  altId = 'altId',
  apartmentCodeb2b = 'apartmentCode',
  serviceProvider = 'serviceProvider',
  departments = 'departments',
  enterprise = 'enterprise',
  contractTypeTHR = 'contractTypeTHR',
  note = 'note',
}

// используетс яисключительно в табличном виде заказа
export enum ORDER_CUSTOM_VISIBILITY_TABLE_FIELD {
  number = 'number',
  fullyPaid = 'fullyPaid',
  firstVisitDateInterval = 'firstVisitDateInterval',
  createdAt = 'createdAt',
  visitDateIntervals = 'visitDateIntervals',
  status = 'status',
  brand = 'brand',
  customerPhones = 'customerPhones',
  customerEmail = 'customerEmail',
  shop = 'shop',
  legalEntity = 'legalEntity',
  region = 'region',
  address = 'address',
  productDeliveryIntervals = 'productDeliveryIntervals',
  customerName = 'customerName',
  serviceProvider = 'serviceProvider',
  departments = 'departments',
  enterprise = 'enterprise',
  contractTypeTHR = 'contractTypeTHR',
  lastStatusUpdatedAt = 'lastStatusUpdatedAt',
  note = 'note',
}